import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Season extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "virtualMatches", Model.attribute('virtualMatches'));
    _defineProperty(this, "fechaCierreVotacionesPastorGorbea", Model.attribute('fechaCierreVotacionesPastorGorbea'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
  }
  apiEndpoint() {
    return '/nagusi/match-ratings/seasons' + (this.exists ? '/' + this.data.id : '');
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/Season', Season);